import { Component, OnInit } from '@angular/core';
import { ControlContainer, FormGroup, Validators } from '@angular/forms';
import { DataValidator } from 'app/tools/custom-formgroup-validator';
import { ParentFormGroup } from 'app/tools/parent-formgroup';
import { DialogFactory } from 'sol-tools-ts/dist';

@Component({
  selector: 'text-data-entrega',
  templateUrl: './text-data-entrega.component.html',
  styleUrls: ['./text-data-entrega.component.scss'],
  viewProviders: [ ParentFormGroup ]
})
export class TextDataEntregaComponent implements OnInit {

  private formGroup: FormGroup;
  now: string = new Date().toISOString().split('T')[0];

  constructor(
    private _controlContainer: ControlContainer,
    private _dialogFactory: DialogFactory
  ) {}

  ngOnInit() {
    this.formGroup = this._controlContainer.control as FormGroup;
  }

  async ngAfterViewInit() {
    this._validators();
 }
  
  private _validators() {
    const date = new Date();
    date.setHours(23, 59, 59, 59);
    this.formGroup.get("dtEntrega").setValidators([Validators.required, DataValidator.max(new Date())]);
    this.formGroup.get("dtEntrega").updateValueAndValidity();
  }

  public validarData() {
    if (!this.formGroup.get("dtEntrega").valid) {
      this._dialogFactory.snack("A data não deve ser posterior à atual.", "OK", DialogFactory.SNACK_WARNING)
      this.formGroup.get("dtEntrega").reset();
    }
  }
}
